var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5364 20C19.3434 20 19.9976 19.3659 19.9976 18.5838V4.62281C20.013 4.38061 19.9547 4.13936 19.83 3.92892C19.7054 3.71848 19.5198 3.5481 19.2962 3.43886L18.475 3.14146L16.5257 2.40503L14.2988 1.5553L12.2969 0.807547L10.2921 0.0484592L10.2366 0.0342971L10.184 0.020135C10.0677 -0.00671168 9.94662 -0.00671168 9.83037 0.020135L9.77777 0.0342971L9.70763 0.0484592L0.694786 3.44736C0.474281 3.55723 0.291445 3.7268 0.168489 3.93546C0.0455337 4.14413 -0.0122479 4.38292 0.00216509 4.62281L0.00216509 18.5838C0.00216509 19.3659 0.656379 20 1.46339 20H18.5364ZM1.97482 17.397L9.01501 17.2186V15.1622L1.97482 15.6976V17.397ZM1.97482 14.0038L9.01501 13.1116V11.0552L1.97482 12.3043V14.0038ZM1.97482 10.6134L9.01501 9.00456V6.95389L1.97482 8.91392V10.6134ZM1.97482 7.22014L9.01501 4.89756V2.89787L1.97482 5.55468V7.22014Z",
    fill: "#697077"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.4e118c84.svg";
export { ForwardRef as ReactComponent };